import React from 'react';
import { DeleteContainer, FileName, DeleteIconView } from './AddPo.styled';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
const PoImageDeleteView = ({ name, onDelete, previewImage }) => {
    return (
        <DeleteContainer>
            <FileName className="uploaded-po-filename-dt-mask" id="reportUsage-reportPayment-addPo-fileName" onClick={() => previewImage(name)}>{name}</FileName>
            <DeleteIconView>
                <img
                    id="reportUsage-reportPayment-addPo-deleteIcon"
                    onClick={() => onDelete(name)}
                    src={DeleteLight}
                    alt={'delete'}
                />
            </DeleteIconView>
        </DeleteContainer>
    );
};

export default PoImageDeleteView;
